export const forecastPortions = (
  participantCountValue: string | number,
  peoplePerPortionValue: number | null | undefined,
): string | null => {
  const participants = typeof participantCountValue === 'number'
    ? participantCountValue
    : Number.parseFloat(String(participantCountValue || '').replace(',', '.'));
  const peoplePerPortion = peoplePerPortionValue ?? 0;

  if (!Number.isFinite(participants)
    || participants <= 0
    || !Number.isFinite(peoplePerPortion)
    || peoplePerPortion <= 0) {
    return null;
  }

  const portions = Math.max(0.5, Math.round((participants / peoplePerPortion) * 2) / 2);
  return Number.isInteger(portions) ? String(portions) : portions.toFixed(1);
};
